import { get, shipperPrefix } from './base';

export function getAds(params) {
  return get(`${shipperPrefix}ads/query`, params);
}